import MainMenu from '../pages/main-menu.vue';
import Dashboard from '../pages/dashboard.vue';
import DashboardOffline from '../pages/dashboard-offline.vue';
import NotFoundPage from '../pages/404.vue';
//import Privacidad from '../pages/privacidad.vue';
//import Eula from '../pages/eula.vue';
//import Acerca from '../pages/acerca-de-ohc.vue';
//import Configuracion from '../pages/configuracion.vue';
import RoutesUtils from './../js/RoutesUtils.js';

var routesMain = [
    {
        path: '/',
        // La ayuda se declara por clave y no por ruta a propósito: el resolver del backend casa la
        // ruta por prefijo, y "/" es prefijo de TODAS las demás, así que una ayuda dada de alta con
        // la ruta "/" se acabaría enseñando en cualquier pantalla que no tenga la suya.
        ayuda: 'inicio',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('dashboard', ['ADMIN', 'INSPECTOR'], process.env.TARGET === 'cordova' ? DashboardOffline : Dashboard)
    },
    {
        path: '/index-offline/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('dashboard', ['ADMIN', 'INSPECTOR'], DashboardOffline)
    },
    {
        path: '(.*)',
        component: NotFoundPage,
    },
];


var routesLeft = [{
    path: '/main-menu/',
    beforeEnter: function(routeTo, routeFrom, resolve, reject) {
        if (!RoutesUtils.checkAuth()) {
            reject();
        } else {
            resolve();
        }
    },
    component: MainMenu
}];
export { routesMain, routesLeft };